// extracted by mini-css-extract-plugin
module.exports = {"scroll-black":"Layout_scroll-black__Km7qD","layout":"Layout_layout__CBbYg"};